"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ReactSearchAutocomplete", {
  enumerable: true,
  get: function get() {
    return _ReactSearchAutocomplete.default;
  }
});

var _ReactSearchAutocomplete = _interopRequireDefault(require("./components/ReactSearchAutocomplete.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }